module.exports = __webpack_public_path__ + "static/media/member-logo-white.e3648e28.svg";